import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { getUsers } from '../../api/user/getUsers';
import UsersTable from '../../components/Users/UsersTable';
import { setLoading } from '../../store/UI';
import { User } from '../../types/model/user';
import { StoreInterfaces } from '../../types/store';

const Users = () => {
  const dispatch = useDispatch();
  const [users, setUsers] = useState<User[]>([]);
  const navigate = useNavigate();
  const session = useSelector((state: StoreInterfaces) => state.session);

  const fetchUsers = async () => {
    try {
      dispatch(setLoading(true));
      const data = await getUsers();
      setUsers(data);
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleRequestRefresh = () => {
    fetchUsers();
  };

  const handleUserRowClick = (user: User) => {
    if (session.isAdministrator) {
      navigate(`/admin/accounts/${user.accountId}/users/${user.id}`);
    }
  };

  return (
    <UsersTable
      tableData={users}
      onRequestRefresh={handleRequestRefresh}
      onRowClick={handleUserRowClick}
    />
  );
};

export default Users;
